import { useState } from 'react';

const useCopyToClipboard = () => {
  const [isCopied, setIsCopied] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const copyToClipboard = async (text: string) => {
    if (!text || typeof window === 'undefined') return;

    if (!navigator.clipboard?.writeText) {
      setError('Clipboard API not available');

      return;
    }

    if (!document.hasFocus()) {
      setError('Document is not focused. Clipboard write blocked.');

      return;
    }

    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      setError(null);

      setTimeout(() => setIsCopied(false), 1000);
    } catch (err) {
      setError('Failed to copy text');
      console.error('Failed to copy text:', err);
    }
  };

  return { copyToClipboard, error, isCopied };
};

export default useCopyToClipboard;
